import React from "react"
import styles from "./styles.scss"
import MenuBar from "components/MenuBar"

class BlogPost extends React.Component {
  render() {
    const {
      title,
      author,
      date,
      backgroundImage,
      backgroundColor,
      children,
    } = this.props

    return (
      <main className={styles.container}>
        <div
          className={styles.headerContainer}
          style={{
            backgroundImage: `url(${backgroundImage})`,
            "--backgroundTint": backgroundColor,
          }}
        >
          <div className={styles.wrapper}>
            <MenuBar variant="white" />
            <h1 className={styles.title}>{title}</h1>
            <p>
              Skrevs av {author}, den {date}
            </p>
            <div className={styles.textContainer}>{children}</div>
          </div>
        </div>
      </main>
    )
  }
}

export default BlogPost



// WEBPACK FOOTER //
// ./src/components/BlogPost/index.jsx